import { useTranslation } from "react-i18next";

import { Form, Header, Message, TextArea } from "semantic-ui-react";

import { MultiLineParagraph } from "components/lib/UI";

const AssessmentFeedback = ({
  field,
  fieldValue = "",
  updateIdea,
  isEditing,
}) => {
  const { t } = useTranslation();

  if (!isEditing) {
    return (
      <>
        <Header size="tiny">Feedback</Header>
        <MultiLineParagraph content={fieldValue} />
      </>
    );
  }

  return (
    <Form>
      <Message size="small">
        The contents of this field will be used by the {t("generic.challenge")}{" "}
        manager to provide direct feedback to the {t("generic.idea")} author.
      </Message>
      <TextArea
        value={fieldValue}
        placeholder={`Enter feedback to the ${t("generic.idea")} author...`}
        onChange={(_e, { value }) => updateIdea(value, ["templated", field.id])}
      />
    </Form>
  );
};

export default AssessmentFeedback;
